import { handleError } from './apiUtils'
import { getConfigurationAsync, xKMSClient } from './httpMethods'
import { VersionApi } from './kmsapiclient'

/**
 * Fetches the KMS version asynchronously.
 *
 * @returns A promise that resolves to a string representing the KMS version.
 */
export async function getKmsVersionAsync(): Promise<string> {
  try {
    const kmsVersionApi = new VersionApi(getConfigurationAsync(false))
    const response = (await kmsVersionApi.kmsVersion(xKMSClient)).data
    return response
  } catch (error) {
    handleError(error, false)
    return Promise.reject(error)
  }
}
